<div class="list-container">
  <ng-container *ngFor="let item of items; let last = last">
    <div class="item-row" [class]="item.color" (click)="handleItemClick(item)">
      <i-tabler [name]="item.iconLeft"></i-tabler>
      <span class="name">{{item.text}}</span>
      <i-tabler [name]="item.iconRight"></i-tabler>
    </div>
    <div *ngIf="!last" class="divider"></div>
  </ng-container>
</div>
